'use strict';

import {waitForDependencies} from "../../_imports/utils/utils.common";

const setHeroBannerMinHeight = () => {
    const $hero = $(".hero");
    
    const height = $(".hero .container > .row").outerHeight();
    if (!$(".hero").hasClass("small") && !$(".hero").hasClass("job-detail")){
        $hero.css("min-height", height + "px");
    }
};

waitForDependencies(() => {
    if($('.hero').length) {
        setHeroBannerMinHeight();
    }
});